module.exports = __webpack_public_path__ + "img/qrcode_brand.2ea965db.png";